// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".md-ripple span.md-list-item-text[data-v-2db2f9fb]{overflow:inherit;position:relative;width:auto}div.file-name-text[data-v-2db2f9fb]{line-height:50px;text-align:right}", ""]);
// Exports
module.exports = exports;
